import { render, staticRenderFns } from "./Transformer.vue?vue&type=template&id=485efd3a&scoped=true&"
import script from "./Transformer.vue?vue&type=script&lang=js&"
export * from "./Transformer.vue?vue&type=script&lang=js&"
import style0 from "./Transformer.vue?vue&type=style&index=0&id=485efd3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485efd3a",
  null
  
)

export default component.exports